import React, { useContext, useState } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { Context } from '../../App';

export default function AdmPaymentEdit({payment, close, updatePayment}) {
    const {setIsConnected} = useContext(Context);
    const user = JSON.parse(sessionStorage.getItem('user'));

    const [load, setLoad] = useState(true);
    const [statut, setStatut] = useState(payment ? payment.statut : '');
    

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true);

        const query = new URLSearchParams({ _id: payment._id }).toString();

        fetch(process.env.REACT_APP_API_URL + '/adm/payment?' + query, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: JSON.stringify({statut})
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    updatePayment(json);
                    close();
                } else {
                    const error = await response.json();
                    console.error('Erreur lors de la màj de la demande de paiement:', error);
                }
            }
        }).catch(error => {
            console.error("Erreur lors de la màj de la demande de paiement:", error);
        }).finally(() => {
            setLoad(false);
        });
    };

    return (
        <Box component='form' onSubmit={handleSubmit} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2}}>
            <Typography variant="h6" align='center' color='focus' sx={{mb:2}}>Mettre à jour la demande</Typography>

            <TextField select label="Statut" value={statut} onChange={(e)=>setStatut(e.target.value)} size="small" sx={{minWidth:'200px', width:'80%'}} required
            slotProps={{ select: { native: true }, inputLabel:{shrink: true} }}>
                <option value="" disabled>Sélectionner un statut</option>
                <option value="en cours de traitement">En cours de traitement</option>
                <option value="paiement effectué">Paiement effectué</option>
                <option value="terminée">Terminée</option>
                {user.role==='super admin' && <option value="annulée">Annulée</option>}
            </TextField>

            <Button variant="contained" color="focus" type='submit' sx={{mt:2, alignSelf:'center', color:'white'}}>Mettre à jour</Button>
            
        </Box>
    );
}